import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { ConfigService } from '../../shared/services/config.service';
import { FunctionUtil } from '../../shared/utilities/function.util'

@Component({
  selector: 'smt-unauthorized',
  template: `
        <main class="page-content">
            <h1>You are not authorized to view this page.  You will be redirected.</h1>
        </main>
    `,
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {    
	constructor(@Inject(DOCUMENT)private _document: any, private _configService: ConfigService) { 
        this.delayedRedirect();
    }

    delayedRedirect: Function = FunctionUtil.DelayFunctionExecution(() => { this._document.location.href = this._configService.appSettings.HapBaseUrl; }, 3000);
}
